module.exports = __webpack_public_path__ + "74b9d175f0671e88e3d62deb3df745a7.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/broschuere21_image.jpg
// module id = 749
// module chunks = 0